var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal__backdrop"}),_c('div',{staticClass:"modal__dialog"},[_c('div',{staticClass:"modal__body"},[_vm._t("body")],2)])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }